import { compose } from '../../../../../i18n/dictionary.js';
import { dictionary as commonDictionary } from './schema.common.dictionary.js';
import { dictionary as configurationDictionary } from './schema.configuration.dictionary.js';
export const dictionary = compose(commonDictionary, configurationDictionary);
